"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormRichSelectCurrent", {
    enumerable: true,
    get: function() {
        return FormRichSelectCurrent;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Button = require("../../../Button/Button");
const _FormGroupContext = require("../../../../contexts/FormGroupContext");
const _FormRichSelectContext = require("../FormRichSelectContext");
const _Theme = require("../../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormRichSelectCurrent = (param)=>{
    let { children, allowOverflow = false, ...props } = param;
    const { colors, borderRadius, spacers, focusOutline } = (0, _Theme.useTheme)();
    const ref = /*#__PURE__*/ (0, _react.createRef)();
    const [focus, setFocus] = (0, _react.useState)(false);
    const [hasBeenOpened, setHasBeenOpened] = (0, _react.useState)(false);
    const { disabled, open, setOpen, reference } = (0, _react.useContext)(_FormRichSelectContext.FormRichSelectContext);
    const { error, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const showOutline = focus;
    (0, _react.useEffect)(()=>{
        if (open) {
            setHasBeenOpened(true);
        } else if (hasBeenOpened) {
            var _ref_current;
            setHasBeenOpened(false);
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
        }
    }, [
        hasBeenOpened,
        open,
        ref
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        ref: reference,
        "aria-describedby": hintId,
        className: _style.default.dynamic([
            [
                "ad21d86b5a331d7",
                [
                    error != null ? colors.danger : showOutline ? colors.dark : colors.border,
                    borderRadius,
                    spacers.s3,
                    spacers.s5,
                    showOutline ? "0 0 0 ".concat(focusOutline.size, " ").concat(error == null ? focusOutline.colors.default : focusOutline.colors.error, " !important") : "none",
                    allowOverflow ? "visible" : "hidden",
                    allowOverflow ? "initial" : "ellipsis"
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "ad21d86b5a331d7",
                [
                    error != null ? colors.danger : showOutline ? colors.dark : colors.border,
                    borderRadius,
                    spacers.s3,
                    spacers.s5,
                    showOutline ? "0 0 0 ".concat(focusOutline.size, " ").concat(error == null ? focusOutline.colors.default : focusOutline.colors.error, " !important") : "none",
                    allowOverflow ? "visible" : "hidden",
                    allowOverflow ? "initial" : "ellipsis"
                ]
            ]
        ])
    }, children), /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        ref: ref,
        size: "sm",
        variant: "secondary",
        type: "button",
        disabled: disabled,
        ...props,
        onFocus: ()=>{
            setFocus(true);
        },
        onBlur: ()=>{
            setFocus(false);
        },
        onClick: (e)=>{
            if (props.onClick != null) {
                props.onClick(e);
            }
            setOpen(!open);
        }
    }, open ? "Cancel" : "Edit"), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "ad21d86b5a331d7",
        dynamic: [
            error != null ? colors.danger : showOutline ? colors.dark : colors.border,
            borderRadius,
            spacers.s3,
            spacers.s5,
            showOutline ? "0 0 0 ".concat(focusOutline.size, " ").concat(error == null ? focusOutline.colors.default : focusOutline.colors.error, " !important") : "none",
            allowOverflow ? "visible" : "hidden",
            allowOverflow ? "initial" : "ellipsis"
        ]
    }, "div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid ".concat(error != null ? colors.danger : showOutline ? colors.dark : colors.border, ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";padding:").concat(spacers.s3, " ").concat(spacers.s5, ";-webkit-box-shadow:").concat(showOutline ? "0 0 0 ".concat(focusOutline.size, " ").concat(error == null ? focusOutline.colors.default : focusOutline.colors.error, " !important") : "none", ";-moz-box-shadow:").concat(showOutline ? "0 0 0 ".concat(focusOutline.size, " ").concat(error == null ? focusOutline.colors.default : focusOutline.colors.error, " !important") : "none", ";box-shadow:").concat(showOutline ? "0 0 0 ".concat(focusOutline.size, " ").concat(error == null ? focusOutline.colors.default : focusOutline.colors.error, " !important") : "none", "}span.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%;max-width:-webkit-calc(100% - 4.5rem);max-width:-moz-calc(100% - 4.5rem);max-width:calc(100% - 4.5rem);overflow:").concat(allowOverflow ? "visible" : "hidden", ";-o-text-overflow:").concat(allowOverflow ? "initial" : "ellipsis", ";text-overflow:").concat(allowOverflow ? "initial" : "ellipsis", "}")));
};
FormRichSelectCurrent.displayName = "FormRichSelectCurrent";

//# sourceMappingURL=FormRichSelectCurrent.js.map